import DynamicRowList from './DynamicRowList';

export default DynamicRowList;
